export const DISBURSEMENT_STATUS_ENUM = {
  DISBURSED: 'DISBURSED',
  IN_PROCESS: 'IN_PROCESS',
  WAITING_FOR_WITHDRAWAL: 'WAITING_FOR_WITHDRAWAL',
};

export default {};
